import { MatterRowContextMenu } from "@/components/features/matters/MatterRowContextMenu";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import { CASE_MATTER_STATUS_CATEGORY_OPTIONS } from "@/lib/data/static/matterStatics";
import type { MatterSearchResult } from "@/lib/data/requests/matters/search-matters";
import { useQuery } from "@tanstack/react-query";
import { useMemo, useState, type ReactNode } from "react";

type MassTortMatterRowContextMenuProps = {
  matter: MatterSearchResult;
  trigger: ReactNode;
};

export function MassTortMatterRowContextMenu({
  matter: searchMatter,
  trigger,
}: MassTortMatterRowContextMenuProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { data: matterData } = useQuery({
    ...retrieveMatterQueryOptions(searchMatter.id),
    enabled: isMenuOpen,
  });
  const matter = useMemo(() => {
    const detailedMatter = matterData?.data;

    return {
      attorneyFee: detailedMatter?.attorneyFee ?? null,
      dateModified: detailedMatter?.dateModified ?? searchMatter.dateModified,
      emailAddress: detailedMatter?.emailAddress ?? searchMatter.emailAddress,
      id: searchMatter.id,
      status: detailedMatter?.status
        ? {
            id: detailedMatter.status.id,
            label: detailedMatter.status.label,
          }
        : searchMatter.status,
      statusId: detailedMatter?.statusId ?? searchMatter.statusId,
      title: detailedMatter?.title ?? searchMatter.title,
    };
  }, [matterData?.data, searchMatter]);

  return (
    <MatterRowContextMenu
      allowedStatusCategories={CASE_MATTER_STATUS_CATEGORY_OPTIONS}
      matter={matter}
      trigger={trigger}
      onOpenChange={setIsMenuOpen}
    />
  );
}
